(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[929],{

/***/ 2954:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries",
      function () {
        return __webpack_require__(7209);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 7209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ industries; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/industries-sections/desktop/begin-at-the-start.tsx



var DesktopBeginAtStart = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col mt-10 space-y-5 text-center pt-10 justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "subheading text-secondary-dark",
                        children: "The time to start saving is now."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "h3 text-text-color-high-em-light",
                        children: "Begin at the start"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-[200px] h-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex px-32 pt-14 pb-64",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-10 xl:space-x-20 flex-row ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 2xl:flex 2xl:justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/industries/begin.png",
                                alt: "begin",
                                width: 560,
                                height: 560
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-1/2 items-center space-y-10 flex-col justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h4 xl:h3 text-text-color-high-em-light",
                                            children: "Flex Options"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-text-color-mid-em-light",
                                            children: "Sign-up with SimpleWaste and start your savings immediately. On our plan, your value and savings increase over time. We provide flexible options with terms that fit your needs."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h4 xl:h3 text-text-color-high-em-light",
                                            children: "Administrative Control"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-text-color-mid-em-light",
                                            children: "Maintain your facility operations with SimpleWaste innovation. Start using the platform that enables process, service, and vendor administration with ease."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var begin_at_the_start = (DesktopBeginAtStart);

// EXTERNAL MODULE: ./components/button.tsx
var components_button = __webpack_require__(6625);
// EXTERNAL MODULE: ./components/schedule-demo.tsx
var schedule_demo = __webpack_require__(4981);
;// CONCATENATED MODULE: ./components/industries-sections/desktop/find-your-plan.tsx




var DesktopFindYourPlan = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
            overrideClassName: "py-10 px-12 xl:p-16 w-[80%] absolute lg:-mt-24 xl:-mt-36 w-full rounded-2xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h3 xl:h2 text-light flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Find your plan."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Explore our options."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(schedule_demo/* default */.Z, {
                            children: function(setIsModalOpen) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    buttonType: "base",
                                    size: "3xl",
                                    onClick: function() {
                                        return setIsModalOpen(true);
                                    },
                                    children: "Schedule Demo"
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var find_your_plan = (DesktopFindYourPlan);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/hero-banner.tsx



var DesktopHeroBanner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex justify-center items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/images/industries/industries-hero.png",
                    alt: "industries-hero-banner",
                    width: 2560,
                    height: 883,
                    layout: "intrinsic"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute rounded-2xl bg-black bg-opacity-50 p-8 xl:p-10 w-[85%] flex items-center justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col space-y-6 justify-center items-center text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row space-x-4 justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                        overrideClassName: "rounded-xl text-light px-2 py-px",
                                        children: "Expertise"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                        overrideClassName: "rounded-xl text-light px-2 py-px",
                                        children: "Reliability"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                        overrideClassName: "rounded-xl text-light px-2 py-px",
                                        children: "Innovation"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "h1 text-light",
                                children: "Industries"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-body-xl text-light flex flex-col space-y-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "We represent a diverse client base, managing all waste and recycling categories."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: "Each industry represents its own unique facility, waste, and recycling requirements."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: "SimpleWaste provides the expertise, innovation, and reliability to facilitate every project."
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_banner = (DesktopHeroBanner);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/industries-gradient.tsx


var DesktopIndustriesGradient = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gradient_container/* default */.Z, {
            overrideClassName: "px-40 py-16 space-y-2 flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "h1 text-light",
                    children: "Diversity"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "subheading text-light",
                    children: "Representing clients in every industry."
                })
            ]
        })
    });
};
/* harmony default export */ var industries_gradient = (DesktopIndustriesGradient);

// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/distribution-warehouse.tsx






var DesktopDistributionWarehouse = function(param) {
    var inView4 = param.inView4;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-72 px-24 flex flex-col xl:flex-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-end ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden xl:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/distributions.png",
                            alt: "distributions",
                            className: "rounded-3xl",
                            width: 760,
                            height: 512
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "xl:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/distributions.png",
                            alt: "distributions",
                            className: "rounded-3xl",
                            width: 660,
                            height: 442
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shadow-lg-light absolute bg-opacity-80 -mt-56 -ml-12 xl:ml-10 bg-light \n    w-[45%] 2xl:w-[55%] blur-content rounded-2xl p-6",
                style: {
                    visibility: inView4 ? "visible" : "hidden",
                    transform: inView4 ? "translateX(0%)" : "translateX(-10%)",
                    transition: "transform 500ms ease-in"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col ml-2 space-y-5 \n          ".concat(isExpanded ? "h-[560px] xl:h-[540px] xl-2:!h-[490px] 2xl:!h-[420px]" : "h-[420px] xl:h-[420px] xl-2:!h-[390px] 2xl:!h-[320px] ", "\n           transition-[height] ease-out duration-500"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h2",
                                children: "04"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h4 xl:h3 text-background-primary-dark",
                            children: "Distribution Centers & Warehouses"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                overrideClassName: "w-[40%] h-2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " text-text-color-mid-em-light space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Capitalize on savings and efficiency through our Sole Source Management program. A combination of technology, purchasing, and operations support provides your management teams with the tools necessary for streamlined service delivery with 100% transparency."
                                }),
                                isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Waste profile management and equipment optimization are integral for the collection and handling of the unique waste and recycling byproducts generated from DC and Warehouse facilities."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        return setIsExpanded(!isExpanded);
                                    },
                                    children: isExpanded ? "Read less" : "Read more"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var distribution_warehouse = (DesktopDistributionWarehouse);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/healthcare.tsx





/* eslint-disable @next/next/no-img-element */ var DesktopHealthcare = function(param) {
    var inView5 = param.inView5;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-32 flex justify-center items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/industries/healthcare.png",
                    alt: "healthcare"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shadow-lg-light absolute bg-opacity-80 bg-light blur-content \n          w-[95%] xl:w-[80%] rounded-2xl p-6",
                style: {
                    visibility: inView5 ? "visible" : "hidden",
                    opacity: inView5 ? 0.9 : 0,
                    transition: "opacity 500ms ease-in"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col ml-2 space-y-5 \n          ".concat(isExpanded ? "h-[515px] xl:h-[550px] 2xl:h-[520px]" : "h-[380px] xl:h-[370px] 2xl:h-[340px]", "\n           transition-[height] ease-out duration-500"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h2",
                                children: "05"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h3 text-background-primary-dark",
                            children: "Healthcare"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                overrideClassName: "w-[22%] h-2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " text-text-color-mid-em-light space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "SimpleWaste represents all healthcare facility types with emphasis on the specialized management of all healthcare-unique waste profiles."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " xl:block",
                                    children: "Our service model and technology platform provides cost reduction with 100% transparency. We've designed our platform to benefit single units, multiple locations, and IDNs, with 24/7 access to live data, billing, and compliance reports."
                                }),
                                isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "SimpleWaste's unique technology platform provides key functionality to support your specialized waste and recycling programs. Our Sole Source User Interface provides unlimited integration across multiple facility types and operations for detailed waste profile management and connected workflow."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We keep your operations team up to speed with KPI and data metrics specific to the healthcare industry."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "hidden xl:block",
                                            children: "At SimpleWaste we design effective solutions that flow seamlessly within your operational footprint."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        return setIsExpanded(!isExpanded);
                                    },
                                    children: isExpanded ? "Read less" : "Read more"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var healthcare = (DesktopHealthcare);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/hoa-residential.tsx





/* eslint-disable @next/next/no-img-element */ var DesktopHoaResidential = function(param) {
    var inView7 = param.inView7;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row-reverse",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-background-mid-em flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shadow-lg-light absolute bg-opacity-80  bg-light \n          w-[65%] xl:w-[60%] blur-content rounded-2xl p-6",
                    style: {
                        visibility: inView7 ? "visible" : "hidden",
                        transform: inView7 ? "translateX(-150%)" : "translateX(-158%)",
                        // opacity: inView6 ? 0.9 : 0,
                        transition: "transform 500ms ease-in"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col ml-2 space-y-5\n            ".concat(isExpanded ? "h-[490px] xl:h-[500px] xl-2:!h-[460px]" : "h-[350px] xl:h-[360px] xl-2:!h-[340px] ", "\n             transition-[height] ease-out duration-500"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h2",
                                    children: "07"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h4 xl:h3 text-background-primary-dark",
                                children: "HOAs & Residential"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                    overrideClassName: "w-[22%] h-2"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " text-text-color-mid-em-light space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "SimpleWaste represents HOA and residential communities nationwide."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our technology platform provides complete program and service visibility for HOA leadership and individual residents. With SimpleWaste, you can manage your refuse services with ease."
                                    }),
                                    isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Benefit from our procurement agency by allowing SimpleWaste to represent your association."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "We negotiate your vendor options while providing a single point of contact experience through our sole source user interface. Residents can log in to check a pick-up status, request additional service options, or pay their bills."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-full items-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        onClick: function() {
                                            return setIsExpanded(!isExpanded);
                                        },
                                        children: isExpanded ? "Read less" : "Read more"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/industries/hoa.jpg",
                    alt: "hoa",
                    width: 700,
                    height: 512
                })
            })
        ]
    });
};
/* harmony default export */ var hoa_residential = (DesktopHoaResidential);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/hospitality-venue.tsx





/* eslint-disable @next/next/no-img-element */ var DesktopHospitalityVenue = function(param) {
    var inView3 = param.inView3;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shadow-lg-light absolute bg-opacity-50 mt-5 ml-16 xl:mt-16 xl:ml-24 bg-black \n          w-[60%] xl:w-[45%] 2xl:w-[35%] rounded-2xl p-6",
                style: {
                    visibility: inView3 ? "visible" : "hidden",
                    transform: inView3 ? "translateX(0%)" : "translateX(-10%)",
                    transition: "transform 500ms ease-in"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col ml-2 space-y-5 \n          ".concat(isExpanded ? "h-[480px]  xl:h-[570px] xl-2:!h-[540px] 2xl:!h-[590px]" : "h-[345px] xl:h-[360px] xl-2:!h-[335px] 2xl:!h-[355px]", "\n           transition-[height] ease-out duration-500"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h2",
                                children: "03"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h4 xl:h3 text-light",
                            children: "Hospitality & Venue\u200B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                overrideClassName: "w-[40%] h-2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "subheading text-light space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Our unique service model and technology platform are ideal for operators of restaurants, hotels, casinos, entertainment venues, gaming establishments, golf & country clubs, resorts, and more!"
                                }),
                                isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We combine all aspects of procurement, technology, and support to provide your business with the best pricing, guaranteed. Optimize your operations, administration, and purchasing through our Sole Source User Interface."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "hidden xl:block",
                                            children: "Immediate savings are available through the SimpleWaste technology platform."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        return setIsExpanded(!isExpanded);
                                    },
                                    children: isExpanded ? "Read less" : "Read more"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/industries/hospitality.png",
                    alt: "hospitality"
                })
            })
        ]
    });
};
/* harmony default export */ var hospitality_venue = (DesktopHospitalityVenue);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/manufacturing-processing.tsx






var DesktopManufacturingProcessing = function(param) {
    var inView2 = param.inView2;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-end",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full justify-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden xl:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/manufacturing2.png",
                            alt: "manufacturing",
                            className: "rounded-3xl",
                            width: 760,
                            height: 512
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "xl:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/manufacturing2.png",
                            alt: "manufacturing",
                            className: "rounded-3xl",
                            width: 660,
                            height: 442
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shadow-lg-light absolute bg-opacity-90 -mt-44 xl:-mt-32 bg-light blur-content \n          w-[45%] 2xl:w-[55%] rounded-2xl p-6 transition-opacity ",
                style: {
                    visibility: inView2 ? "visible" : "hidden",
                    transform: inView2 ? "translateX(0%)" : "translateX(8%)",
                    transition: "transform 500ms ease-in"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col ml-2 space-y-5\n           ".concat(isExpanded ? "h-[620px] xl:h-[605px] xl-2:!h-[540px] 2xl:!h-[450px]" : "h-[455px] xl:h-[465px] xl-2:!h-[420px] 2xl:!h-[360px]", "\n           transition-[height] ease-in-out duration-500"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h2",
                                children: "02"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h4 xl:h3 text-background-primary-dark",
                            children: "Manufacturing & Food Processing"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                overrideClassName: "w-[40%] h-2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " text-text-color-mid-em-light space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "SimpleWaste represents all sectors of the manufacturing industry."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Our platform combines technology, procurement, and operations support providing your management teams the tools they require for streamlined service delivery with 100% transparency."
                                }),
                                isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "space-y-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "At SimpleWaste we design effective solutions that flow seamlessly within your operational footprint. Waste stream management and equipment optimization are essential for collecting and handling the unique waste profiles generated from the industry."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        return setIsExpanded(!isExpanded);
                                    },
                                    children: isExpanded ? "Read less" : "Read more"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var manufacturing_processing = (DesktopManufacturingProcessing);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/office-mixed-use.tsx






var DesktopOfficeMixedUse = function(param) {
    var inView6 = param.inView6;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row -mb-[7px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden xl:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/office.png",
                            alt: "office",
                            width: 720,
                            height: 712
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "xl:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/office.png",
                            alt: "office",
                            width: 520,
                            height: 512
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " bg-background-mid-em flex items-center justify-center xl:justify-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "shadow-lg-light absolute bg-opacity-90 xl:-ml-96 2xl:-ml-40 bg-light \n          w-[80%] xl:w-[65%] 2xl:w-[50%] blur-content rounded-2xl p-6",
                    style: {
                        visibility: inView6 ? "visible" : "hidden",
                        transform: inView6 ? "translateX(0%)" : "translateX(10%)",
                        transition: "transform 500ms ease-in"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col ml-2 space-y-5 \n            ".concat(isExpanded ? "h-[410px] xl:h-[545px] xl-2:!h-[505px] 2xl:!h-[545px]" : "h-[310px] xl:h-[385px] xl-2:!h-[365px] 2xl:!h-[385px] ", " \n            transition-[height] ease-out duration-500"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h2",
                                    children: "06"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h4 xl:h3 text-background-primary-dark",
                                children: "Office & Mixed Use"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                    overrideClassName: "w-[22%] h-2"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " text-text-color-mid-em-light space-y-2 xl:space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "SimpleWaste represents offices and mixed-use building environments. Our unique service and technology platform are customized to accommodate single tenants or property management groups."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "hidden xl:block",
                                        children: "Through our technology platform, clients are able to secure cost reduction with ease-of-use vendor management across all 50 states."
                                    }),
                                    isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "xl:hidden",
                                                children: "Through our technology platform, clients are able to secure cost reduction with ease-of-use vendor management across all 50 states."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Reduce your property refuse and utility costs through our aggregate purchasing model."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "hidden xl:block",
                                                children: "With the RFP Optimizer you'll be able to automate bids, select preferred vendors, and manage services at a property by property basis. Vendor updates and communication are recorded and tracked within the technology platform, giving your management team access to LIVE data with 100% visibility."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-full items-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        onClick: function() {
                                            return setIsExpanded(!isExpanded);
                                        },
                                        children: isExpanded ? "Read less" : "Read more"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var office_mixed_use = (DesktopOfficeMixedUse);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/offerings/retail-grocery.tsx






var DesktopRetailGrocery = function(param) {
    var inView = param.inView;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-72",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden xl:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/retail-grocery2.png",
                            alt: "retail",
                            className: "rounded-3xl",
                            width: 760,
                            height: 512
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "xl:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/retail-grocery2.png",
                            alt: "retail",
                            className: "rounded-3xl",
                            width: 660,
                            height: 442
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "shadow-lg-light absolute bg-opacity-90 -mt-[600px] bg-light blur-content \n            w-[60%] xl:w-[42%] 2xl:w-[55%] rounded-2xl p-6",
                style: {
                    visibility: inView ? "visible" : "hidden",
                    transform: inView ? "translateX(0%)" : "translateX(-10%)",
                    transition: "transform 500ms ease-in"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col ml-2 space-y-5 \n          ".concat(isExpanded ? "h-[510px] xl:h-[550px] xl-2:!h-[530px] 2xl:!h-[500px]" : "h-[370px] xl:h-[390px] xl-2:!h-[390px] 2xl:!h-[370px]", "\n           transition-[height] ease-out duration-500 "),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "h2",
                                children: "01"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h4 xl:h3 text-background-primary-dark",
                            children: "Retail & grocery"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                overrideClassName: "w-[40%] h-2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-text-color-mid-em-light space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "SimpleWaste represents all sectors of the retail industry."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Our unique service and technology platform is ideal for retail, storefronts, grocery, and convenience stores! Your various waste and recycling profiles are seamlessly managed through our technology portal."
                                }),
                                isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Unlock ease-of-use functionality when it comes to administration, procurement, and ongoing operations support."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Find the best pricing options for your represented regions through our automated RFP Optimization Tool."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-full items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        return setIsExpanded(!isExpanded);
                                    },
                                    children: isExpanded ? "Read less" : "Read more"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var retail_grocery = (DesktopRetailGrocery);

;// CONCATENATED MODULE: ./components/industries-sections/desktop/thumb-on-the-pulse.tsx


var DesktopThumbOnPulse = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col px-20 xl:px-36 space-y-5 xl:space-y-10 pb-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-16 w-full flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-3 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "subheading text-text-color-mid-em-light",
                            children: "Industry solutions specific to your business."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h2 xl:h1 text-text-color-high-em-light",
                            children: "Thumb on the pulse"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row space-x-12 justify-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/industries/data-driven.png",
                                    alt: "data-driven",
                                    width: 560,
                                    height: 340
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-1/2 flex-col items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-3 xl:space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h4 xl:h3 text-text-color-high-em-light",
                                            children: "Data-driven solutions"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-text-color-mid-em-light flex flex-col space-y-2 xl:space-y-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Our industry solutions portfolio utilizes a wide array of options specific to your business, waste profiles, and facility type. Find the solution that's right for you."
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row space-x-8 xl:space-x-28 justify-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-1/2 items-center justify-center flex-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-3 xl:space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h4 xl:h3 text-text-color-high-em-light",
                                            children: "Technology Integration"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-text-color-mid-em-light flex flex-col space-y-2 xl:space-y-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Power your operations with our technology stack. Consolidate the management of your programs, services, and vendors with our platform."
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1/2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/industries/tech-integ.png",
                                    alt: "tech-integ",
                                    width: 560,
                                    height: 432
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var thumb_on_the_pulse = (DesktopThumbOnPulse);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/begin-at-the-start.tsx



var MobileBeginAtStart = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:px-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col py-10 px-6 space-y-3 text-center justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-body-md 2xs:text-body-xl text-secondary-dark",
                        children: "The time to start saving is now."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "h5 sm:h4 text-text-color-high-em-light",
                        children: "Begin at the start"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: " w-[150px] 2xs:w-[200px] h-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col px-8 md:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-center items-center space-y-10 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/industries/begin.png",
                                alt: "begin",
                                width: 560,
                                height: 560
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center space-y-5 flex-col justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h4 text-text-color-high-em-light",
                                            children: "Flex Options"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-text-color-mid-em-light",
                                            children: "Sign-up with SimpleWaste and start your savings immediately. On our plan your value and savings increase over time. We provide flexible options with terms that fit your needs."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h4 text-text-color-high-em-light",
                                            children: "Administrative Control"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-text-color-mid-em-light",
                                            children: "Maintain your facility operations with SimpleWaste innovation. Start using the platform that enables process, service, and vendor administration with ease."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var mobile_begin_at_the_start = (MobileBeginAtStart);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/find-your-plan.tsx




var MobileFindYourPlan = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full flex justify-center mt-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
            overrideClassName: "z-0 w-[90%] rounded-2xl -mb-20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col sm-3:justify-between md:space-y-0 sm-3:flex-row md:space-x-2 py-14 px-10 space-y-4 sm:space-y-3 items-center sm:items-start sm-3:items-center md:items-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h5 xs:h4 flex-col text-light",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Find your plan."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Explore our options."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full sm:w-auto justify-center sm-3:pt-3 md:pt-0 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(schedule_demo/* default */.Z, {
                            children: function(setIsModalOpen) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    size: "base",
                                    full: true,
                                    className: "!bg-light !text-md xl:!text-lg !rounded-md !text-gray-700",
                                    onClick: function() {
                                        return setIsModalOpen(true);
                                    },
                                    children: "Schedule Demo"
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_find_your_plan = (MobileFindYourPlan);

// EXTERNAL MODULE: ./contexts/theme-context.tsx
var theme_context = __webpack_require__(9746);
;// CONCATENATED MODULE: ./components/industries-sections/mobile/hero-baner.tsx




var MobileHeroBanner = function() {
    var isTablet = (0,theme_context/* useThemeContext */.TC)().isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-center items-center",
        children: [
            isTablet ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/industries/industries-hero.png",
                alt: "hero-mobile",
                width: 1023,
                height: 512
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden xs:block sm-3:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/hero-mobile.png",
                            alt: "hero-mobile",
                            width: 768,
                            height: 832
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden sm-3:block md:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/industries-hero.png",
                            alt: "hero-mobile",
                            width: 768,
                            height: 370
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "xs:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/industries/hero-mobile.png",
                            alt: "hero-mobile",
                            width: 540,
                            height: 680
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute md:rounded-2xl bg-black bg-opacity-70 p-4 md:w-[80%] py-6 flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-3 justify-center items-center text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-2 xs:space-y-0 xs:flex-row xs:space-x-4 justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                    overrideClassName: "rounded-xl text-light px-2 py-px",
                                    children: "Expertise"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                    overrideClassName: "rounded-xl text-light px-2 py-px",
                                    children: "Reliability"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                    overrideClassName: "rounded-xl text-light px-2 py-px",
                                    children: "Innovation"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mobile-h2 2xs:mobile-h1 text-light",
                            children: "Industries"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-light text-sm 2xs:text-base flex flex-col space-y-5 px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We represent a diverse client base, managing all waste and recycling categories. Each industry represents its own unique facility, waste, and recycling requirements."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hidden xs:block",
                                    children: "SimpleWaste provides the expertise, innovation, and reliability to facilitate every project."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var hero_baner = (MobileHeroBanner);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/industries-gradient.tsx


var MobileIndustriesGradient = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gradient_container/* default */.Z, {
            overrideClassName: "py-10 px-3 space-y-2 text-center flex flex-col items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "h3 text-light",
                    children: "Diversity"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-body-lg text-light",
                    children: "Representing clients in every industry."
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_industries_gradient = (MobileIndustriesGradient);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/distribution-warehouse.tsx





var MobileDistributionWarehouse = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-5 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "h2",
                            children: "04"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mobile-h3 2xs:mobile-h2 text-background-primary-dark",
                        children: "Distribution Centers & Warehouses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-[30%] h-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-text-color-mid-em-light space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Capitalize on savings and efficiency through our Sole Source Management program."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "A combination of technology, purchasing, and operations support provides your management teams with the tools necessary for streamlined service delivery with 100% transparency."
                            }),
                            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Waste profile management and equipment optimization are integral for the collection and handling of the unique waste and recycling byproducts generated from DC and Warehouse facilities."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            onClick: function() {
                                return setIsExpanded(!isExpanded);
                            },
                            children: isExpanded ? "Read less" : "Read more"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var offerings_distribution_warehouse = (MobileDistributionWarehouse);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/healthcare.tsx






var MobileHealthcare = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var isTablet = (0,theme_context/* useThemeContext */.TC)().isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-full w-full bg-cover bg-top bg-no-repeat",
            style: {
                backgroundImage: isTablet ? "url('/images/industries/healthcare.png')" : "url('/images/industries/mobile-healthcare.png')"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col bg-opacity-60 blur-content bg-light px-8 py-6 md:space-y-3 space-y-1 xs:space-y-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col md:space-y-3 space-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h2",
                                children: "05"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mobile-h3 2xs:mobile-h2 text-background-primary-dark pb-4",
                            children: "Healthcare"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                            overrideClassName: "w-[30%] h-2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-body-lg 2xs:text-base space-y-2 pt-4 xs:space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-text-color-mid-em",
                                    children: "SimpleWaste represents all healthcare facility types with emphasis on the specialized management of all healthcare-unique waste profiles."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-text-color-mid-em",
                                    children: "Our service model and technology platform provides cost reduction with 100% transparency. We've designed our platf orm to benefit single units, multiple locations, and IDNs, with 24/7 access to live data, billing and compliance reports."
                                }),
                                isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-5 text-text-color-mid-em",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "SimpleWaste's unique technology platform provides key functionality to support your specialized waste and recycling programs. Our Sole Source User Interface provides unlimited integration across multiple facility types and operations for detailed waste profile management and connected workflow."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We keep your operations team up to speed with KPI and data metrics specific to the healthcare industry."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "At SimpleWaste we design effective solutions that flow seamlessly within your operational footprint."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                onClick: function() {
                                    return setIsExpanded(!isExpanded);
                                },
                                children: isExpanded ? "Read less" : "Read more"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var offerings_healthcare = (MobileHealthcare);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/hoa-residential.tsx





var MobileHoaResidential = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-4 px-8 pb-8 bg-background-mid-em border-t",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-5 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "h2",
                        children: "07"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mobile-h3 2xs:mobile-h2 text-background-primary-dark",
                    children: "HOAs & Residential"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                    overrideClassName: "w-[30%] h-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-text-color-mid-em-light space-y-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "SimpleWaste represents HOA and residential communities nationwide."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Our technology platform provides complete program and service visibility for HOA leadership and individual residents. With SimpleWaste, you can manage your refuse services with ease."
                        }),
                        isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Benefit from our procurement agency by allowing SimpleWaste to represent your association."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We negotiate your vendor options while providing a single point of contact experience through our sole source user interface. Residents can log in to check a pick-up status, request additional service options, or pay their bills."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        onClick: function() {
                            return setIsExpanded(!isExpanded);
                        },
                        children: isExpanded ? "Read less" : "Read more"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var offerings_hoa_residential = (MobileHoaResidential);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/hospitality-venue.tsx






var MobileHospitalityVenue = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var isTablet = (0,theme_context/* useThemeContext */.TC)().isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " h-full w-full bg-cover bg-top bg-no-repeat",
            style: {
                backgroundImage: isTablet ? "url('/images/industries/hospitality.png')" : "url('/images/industries/mobile-hospitality.png')"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col bg-opacity-80 bg-black px-8 py-6 md:space-y-3 space-y-1 xs:space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "h2",
                            children: "03"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mobile-h3 2xs:mobile-h2 text-light pb-4",
                        children: "Hospitality & Venue"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-[30%] h-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-light text-sm 2xs:text-base pt-4 space-y-2 xs:space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Our unique service model and technology platform are ideal for operators of restaurants, hotels, casinos, entertainment venues, gaming establishments, golf & country clubs, resorts, and more!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "hidden xs:block",
                                children: "We combine all aspects of procurement, technology, and support to provide your business with the best pricing, guaranteed. Optimize your operations, administration, and purchasing through our Sole Source User Interface."
                            }),
                            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "xs:hidden",
                                        children: "We combine all aspects of procurement, technology, and support to provide your business with the best pricing, guaranteed. Optimize your operations, administration, and purchasing through our Sole Source User Interface."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Optimize your operations, administration, and purchasing through our Sole Source User Interface."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Immediate savings are available through the SimpleWaste technology platform."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            onClick: function() {
                                return setIsExpanded(!isExpanded);
                            },
                            children: isExpanded ? "Read less" : "Read more"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var offerings_hospitality_venue = (MobileHospitalityVenue);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/manufacturing-processing.tsx





var MobileManufacturingProcessing = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-4 px-8 pb-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-5 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "h2",
                            children: "02"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mobile-h3 2xs:mobile-h2 text-background-primary-dark",
                        children: "Manufacturing & Food Processing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-[30%] h-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-text-color-mid-em-light space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "SimpleWaste represents all sectors of the manufacturing industry."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Our unique service and technology platform are ideal for retail, storefronts, grocery, and convenience stores! Your various waste and recycling profiles are seamlessly managed through our technology portal."
                            }),
                            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "At SimpleWaste we design effective solutions that flow seamlessly within your operational footprint. Waste stream management and equipment optimization are essential for collecting and handling the unique waste profiles generated from the industry."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            onClick: function() {
                                return setIsExpanded(!isExpanded);
                            },
                            children: isExpanded ? "Read less" : "Read more"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var offerings_manufacturing_processing = (MobileManufacturingProcessing);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/office-mixed-use.tsx





var MobileOfficeMixedUse = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-8 pt-8 pb-4 bg-background-mid-em lg:-mt-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-5 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "h2",
                        children: "06"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mobile-h3 2xs:mobile-h2 text-background-primary-dark",
                    children: "Office & Mixed Use"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                    overrideClassName: "w-[30%] h-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-text-color-mid-em-light space-y-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "SimpleWaste represents offices and mixed-use building environments. Our unique service and technology platform are customized to accommodate single tenants or property management groups."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Through our technology platform clients are able secure cost reduction with ease-of-use vendor management across all 50 states."
                        }),
                        isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Reduce your property refuse and utility costs through our aggregate purchasing model."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "lg:hidden xl:block",
                                    children: "With the RFP Optimizer you'll be able to automate bids, select preferred vendors, and manage services at a property by property basis. Vendor updates and communication are recorded and tracked within the technology platform, giving your management team access to LIVE data with 100% visibility."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        onClick: function() {
                            return setIsExpanded(!isExpanded);
                        },
                        children: isExpanded ? "Read less" : "Read more"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var offerings_office_mixed_use = (MobileOfficeMixedUse);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/offerings/retail-grocery.tsx





var MobileRetailGrocery = function() {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-8 pt-8 pb-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-5 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "h2",
                            children: "01"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mobile-h3 2xs:mobile-h2 text-background-primary-dark",
                        children: "Retail & grocery"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-[30%] h-2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-text-color-mid-em-light space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "SimpleWaste represents all sectors of the retail industry."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Our unique service and technology platform are ideal for retail, storefronts, grocery, and convenience stores! Your various waste and recycling profiles are seamlessly managed through our technology portal."
                            }),
                            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Unlock ease-of-use functionality when it comes to administration, procurement, and ongoing operations support."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Find the best pricing options for your represented regions through our automated RFP Optimization Tool."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            onClick: function() {
                                return setIsExpanded(!isExpanded);
                            },
                            children: isExpanded ? "Read less" : "Read more"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var offerings_retail_grocery = (MobileRetailGrocery);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/thumb-on-the-pulse.tsx


var MobileThumbOnPulse = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-8 md:px-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-3 pb-5 justify-center items-center text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Industry solutions specific to your business."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "h4 sm:h3 text-text-color-high-em",
                        children: "Thumb on the pulse"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/industries/data-driven.png",
                                    alt: "data-driven",
                                    width: 400,
                                    height: 272
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5 text-text-color-high-em-light",
                                        children: "Data-driven solutions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-text-color-mid-em-light flex flex-col space-y-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Our industry solutions portfolio utilizes a wide array of options specific to your business, waste profiles, and facility type. Find the solution that's right for you."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex pt-10 flex-col justify-center items-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/industries/mobile-tech-integ.png",
                                    alt: "tech-integ",
                                    width: 399,
                                    height: 336
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5 text-text-color-high-em-light",
                                        children: "Technology Integration"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-text-color-mid-em-light flex flex-col space-y-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Power your operations with our technology stack. Consolidate the management of your programs, services, and vendors with our platform."
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mobile_thumb_on_the_pulse = (MobileThumbOnPulse);

;// CONCATENATED MODULE: ./components/industries-sections/mobile/index.tsx













var MobileIndustriesComponents = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_baner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_thumb_on_the_pulse, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_industries_gradient, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_retail_grocery, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_manufacturing_processing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_hospitality_venue, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_distribution_warehouse, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_healthcare, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_office_mixed_use, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offerings_hoa_residential, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_begin_at_the_start, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_find_your_plan, {})
        ]
    });
};
/* harmony default export */ var mobile = (MobileIndustriesComponents);

;// CONCATENATED MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  const unobserve = react.useRef();
  const callback = react.useRef();
  const [state, setState] = react.useState({
    inView: !!initialInView
  }); // Store the onChange callback in a `ref`, so we can access the latest instance inside the `useCallback`.

  callback.current = onChange;
  const setRef = react.useCallback(node => {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, (inView, entry) => {
        setState({
          inView,
          entry
        });
        if (callback.current) callback.current(inView, entry);

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root,
        rootMargin,
        threshold,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  react.useEffect(() => {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map

;// CONCATENATED MODULE: ./pages/industries.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















var IndustriesPage = function() {
    // For transitions when scrolled on view
    var ref = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref1 = ref[0], inView = ref[1];
    var ref2 = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref22 = ref2[0], inView2 = ref2[1];
    var ref3 = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref32 = ref3[0], inView3 = ref3[1];
    var ref4 = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref42 = ref4[0], inView4 = ref4[1];
    var ref5 = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref52 = ref5[0], inView5 = ref5[1];
    var ref6 = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref62 = ref6[0], inView6 = ref6[1];
    var ref7 = _slicedToArray(useInView({
        threshold: 0.5,
        triggerOnce: true
    }), 2), ref72 = ref7[0], inView7 = ref7[1];
    var ref8 = (0,theme_context/* useThemeContext */.TC)(), isTablet = ref8.isTablet, isMobile = ref8.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: isTablet || isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_banner, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(thumb_on_the_pulse, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(industries_gradient, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-56 pt-52 px-24 flex flex-col justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: ref1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(retail_grocery, {
                                inView: inView
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: ref22,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(manufacturing_processing, {
                                inView2: inView2
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref32,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hospitality_venue, {
                        inView3: inView3
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref42,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(distribution_warehouse, {
                        inView4: inView4
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref52,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(healthcare, {
                        inView5: inView5
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref62,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(office_mixed_use, {
                        inView6: inView6
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref72,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hoa_residential, {
                        inView7: inView7
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(begin_at_the_start, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(find_your_plan, {})
            ]
        })
    });
};
/* harmony default export */ var industries = (IndustriesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2954); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);